class ProfetPopup {
	constructor() {
		this.popups = false;
	}
	init() {
		this.popups = document.querySelectorAll('[data-popup-id]');
		if (!this.popups.length) {
			return;
		}

		let closePopupLinks = document.querySelectorAll('.close-popup');
		if (closePopupLinks) {
			closePopupLinks.forEach((closePopupLink) => {
				closePopupLink.addEventListener('click', (event) => {
					event.preventDefault();
					let target = closePopupLink.getAttribute('data-close-popup-id');
					let targetElement = document.querySelector('[data-popup-id=' + target + ']');
					if (targetElement) {
						targetElement.classList.remove('active');
						targetElement.classList.remove('fade-in');
					}
				});
			});
		}

		/* Find all links that trigger a popup and set up event listeners for them */
		this.popups.forEach((popup) => {
			let popupId = popup.getAttribute('data-popup-id');
			let triggers = document.querySelectorAll(`a[href="#${popupId}"]`);
			if (triggers) {
				triggers.forEach((trigger) => {
					trigger.addEventListener('click', (event) => {
						event.preventDefault();
						popup.classList.add('active');
						window.setTimeout(() => {
							popup.classList.add('fade-in');
						}, 1);
					});
				});
			}
		});
	}
}
window.addEventListener('load', () => {
	window.ProfetPopup = new ProfetPopup();
	window.ProfetPopup.init();
});

window.addEventListener('load', () => {});
